import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { skillTypeOptions, targetAudienceOptions, difficultyLevels } from "./constants";

export function EditPlanDialog({
  open, onOpenChange, formData, loading,
  onFormChange, onSubmit
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="edit-plan-dialog" className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Edit Training Plan</DialogTitle>
          <DialogDescription>Update your training plan with new content</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <Label htmlFor="edit-title">Plan Title *</Label>
            <Input
              id="edit-title"
              value={formData.title}
              onChange={(e) => onFormChange({ ...formData, title: e.target.value })}
              placeholder="Enter plan title"
              className="mt-1"
            />
          </div>

          <div>
            <Label htmlFor="edit-description">Description *</Label>
            <Textarea
              id="edit-description"
              value={formData.description}
              onChange={(e) => onFormChange({ ...formData, description: e.target.value })}
              placeholder="Brief description of the training plan"
              className="mt-1"
              rows={3}
            />
          </div>

          <div>
            <Label htmlFor="edit-duration">Duration (weeks)</Label>
            <Input
              id="edit-duration"
              type="number" min="1" max="52"
              value={formData.duration_weeks}
              onChange={(e) => onFormChange({ ...formData, duration_weeks: parseInt(e.target.value) })}
              className="mt-1"
            />
          </div>

          <div>
            <Label htmlFor="edit-skill-type">Type of Skill Being Developed</Label>
            <select
              id="edit-skill-type"
              value={formData.skill_type}
              onChange={(e) => onFormChange({ ...formData, skill_type: e.target.value })}
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-emerald-500"
            >
              <option value="">Select a skill type...</option>
              {skillTypeOptions.map((skill) => (
                <option key={skill} value={skill}>{skill}</option>
              ))}
            </select>
          </div>

          <div>
            <Label htmlFor="edit-difficulty-level">Difficulty Level</Label>
            <select
              id="edit-difficulty-level"
              value={formData.difficulty_level}
              onChange={(e) => onFormChange({ ...formData, difficulty_level: e.target.value })}
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-emerald-500"
            >
              {difficultyLevels.map((level) => (
                <option key={level.value} value={level.value}>{level.label}</option>
              ))}
            </select>
          </div>

          <div>
            <Label htmlFor="edit-target-audience">Target Audience</Label>
            <select
              id="edit-target-audience"
              value={formData.target_audience}
              onChange={(e) => onFormChange({ ...formData, target_audience: e.target.value })}
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-emerald-500"
            >
              <option value="">Select target audience...</option>
              {targetAudienceOptions.map((audience) => (
                <option key={audience} value={audience}>{audience}</option>
              ))}
            </select>
          </div>

          <div>
            <Label htmlFor="edit-content">Plan Content *</Label>
            <Textarea
              id="edit-content"
              value={formData.plan_content}
              onChange={(e) => onFormChange({ ...formData, plan_content: e.target.value })}
              placeholder="Enter the detailed training plan content..."
              className="mt-1"
              rows={8}
            />
          </div>

          <div className="flex gap-3">
            <Button onClick={() => onOpenChange(false)} variant="outline" className="flex-1">Cancel</Button>
            <Button
              data-testid="submit-edit-plan-btn"
              onClick={onSubmit}
              disabled={loading}
              className="flex-1 bg-emerald-600 hover:bg-emerald-700"
            >
              {loading ? "Updating..." : "Update Plan"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
